import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { MarkConvInfo } from "../vo/mark-conv-info.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetMarkConvInfoResponse = {
  IconCode: string,
  IconGroupCode: string,
  IconName: string,
  IconCodeBranch: string,
  IconImageUrl: string,
  MarkList: {
    MarkFileName: string,
    MarkFileUrl: string
  }[]
}[];

/**
 * アイコン情報一覧取得サービス
 * @export GetMarkConvInfoService
 * @class GetMarkConvInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMarkConvInfoService extends PlessJsonResponderSub<GetMarkConvInfoResponse> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkConvInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMarkConvInfoService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getMarkConvInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkConvInfoService
   */
  success(data: GetMarkConvInfoResponse) {
    this.model.markConvInfoList = data.map(_ => new MarkConvInfo(
      _.IconCode,
      _.IconGroupCode,
      _.IconName,
      _.IconCodeBranch,
      _.IconImageUrl,
      _.MarkList.map(m => {
        return {
          markFileName: m.MarkFileName,
          markFileUrl: m.MarkFileUrl
        }
      })
    ))
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
